import { createRecordFromEntries } from "../../utils/enum/createRecordFromEntries.js";
import { Locale, type LocalizedString } from "../Locale.js";
import { SubscriptionSize } from "../SubscriptionSize.js";
import { getWeightText } from "../utils/getWeightText.js";
import { subscriptionSizeToAmountMap } from "../utils/subscriptionSizeToAmountMap.js";
import { subscriptionSizeToWeightMap } from "../utils/subscriptionSizeToWeightMap.js";

export const subscriptionSizeNameMap: Record<SubscriptionSize, LocalizedString> = createRecordFromEntries(
	SubscriptionSize,
	Object.values(SubscriptionSize).map((size) => {
		const weight = subscriptionSizeToWeightMap[size];
		const amount = subscriptionSizeToAmountMap[size];
		return [
			size,
			createRecordFromEntries(
				Locale,
				Object.values(Locale).map((locale) => {
					const weightText = getWeightText(locale, weight);
					return [locale, amount === 1 ? weightText : `${amount}× ${weightText}`];
				}),
			),
		];
	}),
);
